import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ViewStatus } from '@uranda/ui';
import { Review } from '../../../../models/review.model';

@Component({
    selector: 'app-review-summary',
    templateUrl: './review-summary.component.html',
    styleUrls: ['./review-summary.component.css'],
    standalone: false
})
export class ReviewSummaryComponent implements OnChanges {
  @Input() viewStatus = ViewStatus.READY;
  @Input() showInRows = false;
  @Input() reviewStats?: Review;
  
  ViewStatus = ViewStatus;
  reviewData: { label: string; count: number }[] = [];
  totalReviews = 0;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reviewStats'] && this.reviewStats) {
      this.updateReviewData();
    }
  }

  private updateReviewData() {
    if (!this.reviewStats?.ratesDistribution) return;

    const distribution = this.reviewStats.ratesDistribution;
    this.totalReviews = this.reviewStats.totalReviews || 0;

    this.reviewData = [
      { 
        label: this.translateService.instant('Excellent'), 
        count: distribution.EXCELLENT || 0 
      },
      { 
        label: this.translateService.instant('Very Good'), 
        count: distribution.VERY_GOOD || 0 
      },
      { 
        label: this.translateService.instant('Good'), 
        count: distribution.GOOD || 0 
      },
      { 
        label: this.translateService.instant('Fair'), 
        count: distribution.FAIR || 0 
      },
      { 
        label: this.translateService.instant('Poor'), 
        count: distribution.POOR || 0 
      },
    ];
  }
}